import { render } from "./HeroiconsOutlinePlay.vue?vue&type=template&id=59763b81"
const script = {}

import exportComponent from "/var/www/vacation-system/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlinePlay.vue"]])

export default __exports__